import { SET_DRAWER_COMPONENT, SET_DRAWER_STATE, SET_DRAWER_COMPONENT_TITLE } from '../mutation-types'

export const components = {
  CREATE_INTERVENTION: 'CREATE_INTERVENTION',
  CLOSE_INTERVENTION: 'CLOSE_INTERVENTION',
  INTERACTION_FILTER: 'INTERACTION_FILTER',
  CREATE_EXEMPTION: 'CREATE_EXEMPTION',
  STUDENT_FILTER: 'STUDENT_FILTER',
  CREATE_CHART_FILTER: 'CREATE_CHART_FILTER',
  ALERT_FILTER: 'ALERT_FILTER'
}

export const componentTitles = {
  CREATE_INTERVENTION: 'intervention_create_drawer_title',
  EDIT_INTERVENTION: 'intervention_edit_drawer_title',
  CLOSE_INTERVENTION: 'intervention_close_title',
  INTERACTION_FILTER: 'filter_interactions_title',
  CREATE_EXEMPTION: 'exemption.form.title',
  EDIT_EXEMPTION: 'exemption.form.edit_title',
  STUDENT_FILTER: 'student.filters.header',
  CREATE_CHART_FILTER: 'dashboard.chart.create_filter',
  ALERT_FILTER: 'admin.alerts.new.alert_filters'
}

const state = () => ({
  state: false,
  title: 'intervention_create_drawer_title',
  component: null
})

const mutations = {
  [SET_DRAWER_STATE] (state, currentState) {
    state.state = currentState
  },
  [SET_DRAWER_COMPONENT] (state, component) {
    state.component = component
  },
  [SET_DRAWER_COMPONENT_TITLE] (state, componentTitle) {
    state.title = componentTitle
  }
}

export default {
  state: state(),
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/rightDrawer.js